import React from "react";
import { Counterparty } from "@common/types/counterparty";
import { NormalizedDescriptionInfo } from "@common/types/normalizedDescription";
import {
    RuleConditionType,
    TransactionRuleCondition,
} from "@common/types/transactionRule";
import { RuleSubaccountsCondition } from "@components/transactionRules/RuleCondition/RuleSubaccountsCondition";
import { RuleCategoryCondition } from "./RuleCategoryCondition";
import { RuleAmountCondition } from "./RuleAmountCondition";
import { RuleCounterpartyCondition } from "./RuleCounterpartyCondition";
import { RuleDescriptionCondition } from "./RuleDescriptionCondition";
import { RuleFinancialAccountsCondition } from "./RuleFinancialAccountsCondition";
import { RuleEntityCondition } from "./RuleEntityCondition";
import { RuleSuggestedCategoryCondition } from "./RuleSuggestedCategoryCondition";
import { RuleDateCondition } from "./RuleDateCondition";
import { RuleClassCondition } from "./RuleClassCondition";
import { RuleSimilarToCondition } from "./RuleSimilarToCondition";
import { RuleAmountRoundingCondition } from "./RuleAmountRoundingCondition";

interface Props {
    condition: TransactionRuleCondition;
    counterparties: Counterparty[];
    normalizedDescriptions: NormalizedDescriptionInfo[];
}

export const RuleCondition: React.FC<Props> = ({
    condition,
    counterparties,
    normalizedDescriptions,
}) => {
    switch (condition.conditionType) {
        case RuleConditionType.CATEGORY:
            return <RuleCategoryCondition condition={condition} />;
        case RuleConditionType.SUGGESTED_CATEGORY:
            return <RuleSuggestedCategoryCondition condition={condition} />;
        case RuleConditionType.AMOUNT:
            return <RuleAmountCondition condition={condition} />;
        case RuleConditionType.CLASS:
            return <RuleClassCondition condition={condition} />;
        case RuleConditionType.DATE:
            return <RuleDateCondition condition={condition} />;
        case RuleConditionType.COUNTERPARTY:
            return (
                <RuleCounterpartyCondition
                    condition={condition}
                    counterparties={counterparties}
                />
            );
        case RuleConditionType.DESCRIPTION_INCLUDES:
        case RuleConditionType.DESCRIPTION_DOES_NOT_INCLUDE:
        case RuleConditionType.DESCRIPTION_IS:
            return <RuleDescriptionCondition condition={condition} />;
        case RuleConditionType.FINANCIAL_ACCOUNTS:
            return <RuleFinancialAccountsCondition condition={condition} />;
        case RuleConditionType.SUBACCOUNTS:
            return <RuleSubaccountsCondition condition={condition} />;
        case RuleConditionType.ENTITY:
            return <RuleEntityCondition condition={condition} />;
        case RuleConditionType.SIMILAR_TO:
            return (
                <RuleSimilarToCondition
                    condition={condition}
                    normalizedDescriptions={normalizedDescriptions}
                />
            );
        case RuleConditionType.AMOUNT_IS_ROUND:
            return <RuleAmountRoundingCondition condition={condition} />;
        case RuleConditionType.AMOUNT_IS_NOT_ROUND:
            return (
                <RuleAmountRoundingCondition condition={condition} isNegated />
            );
        case RuleConditionType.DATE_PROXIMITY:
            return null;
    }
};
